import { render } from "./LbrxMenuUnderline.vue?vue&type=template&id=7d96fd1a"
import script from "./LbrxMenuUnderline.vue?vue&type=script&lang=js"
export * from "./LbrxMenuUnderline.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__